import React from "react";
// import axios from "axios";
import {  useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import CartItem from "./CartItem";
import "./Cart-style.css";
import CheckoutSteps from "../CheckOutProgress";
// const SERVER_URL = process.env.REACT_APP_SERVER_URL


const Cart = () => {
  // const dispatch = useDispatch();
  const { cartProducts, totalPrice, totalAmount } =
    useSelector((state) => state.cartReducer);

  // const placeOrderHandler = () => {
  //   dispatch({ type: "CART_EMPTY" });
  //   localStorage.removeItem("productsInCart");
  // };

  // const placeOrder = () => {
  //   var unique = new Date().valueOf();
  //   var orderNumber = String(unique).substring(3, 13);

  //   var date = new Date();
  //   var day = date.toDateString();
  //   var time = date.toLocaleTimeString();
  //   var orderDate = day + " " + time;
  //   const orderTotal = totalAmount;

  //   const recent_order = {
  //     order_number: orderNumber,
  //     order_date: orderDate,
  //     order_total: orderTotal,
  //     cart_products: cartProducts,
  //   };
  //   localStorage.setItem("recentOrder", JSON.stringify(recent_order));
  //   axios
  //     .post(
  //       SERVER_URL +
  //       "/api/orders/placeorder",
  //       {
  //         orderDetails: recent_order,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization:
  //             "Bearer " +
  //             JSON.parse(localStorage.getItem("userTokenTime")).token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("order placed successfully!");
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   dispatch({
  //     type: "EMPTY_CART",
  //     payload: recent_order,
  //   });
  //   console.log(myOrders);
  // };

  // console.log(totalQuantities, totalPrice);

  // if (!localStorage.getItem("userTokenTime")) return <Navigate to="/" />;
  return (
    <>
      <Navbar />
      <div className="container-z" style={{ paddingTop: "100px" }}>
        <CheckoutSteps step1></CheckoutSteps>

        <div className="row-y" style={{ marginTop: "30px" }}>
          <div className="column1">
            <div className="row-inner">
              <div className="my-cart">My Cart ({cartProducts.length})</div>
            </div>
            <div className="items" style={{ marginTop: "15px" }}>
              <div className="item-row">
                {cartProducts.length > 0 ? (
                  <>
                    {cartProducts.map((item) => (
                      <CartItem key={item._id} item={item} />
                    ))}
                  </>
                ) : (
                  <div className="empty">Your cart is empty!</div>
                )}
              </div>
            </div>
          </div>

          {cartProducts.length > 0 ? (
            <div className="column2">
              <span className="price-heading">PRICE DETAILS ({cartProducts.length} Items)</span>
              <div className="desc-div">
                <div className="price-div">
                  <div className="inner-row">
                    <div>Total MRP </div>
                    <span>₹ {totalPrice}</span>
                  </div>
                </div>
                <div className="discount-div">
                  <div className="inner-row">
                    <div>Discount on MRP</div>
                    <span>-₹{totalPrice - totalAmount}</span>
                  </div>
                </div>
                <div className="delivery-div">
                  <div className="inner-row">
                    <div>Delivery Charges</div>
                    <span><s style={{ marginRight: "5px", color: "black" }}>₹99</s>FREE</span>
                  </div>
                </div>
                <div className="totalprice-div">
                  <div className="inner-row">
                    <div>Total Amount</div>
                    <span>₹ {totalAmount}</span>
                  </div>
                </div>
                <div className="place-order-btn">
                  <Link to="/shipping">
                    <div
                      className="btn"
                    //  onClick={placeOrder}
                    >
                      Proceed To Checkout
                    </div>
                  </Link>
                </div>
                <div className="savings">You will save ₹{totalPrice - totalAmount + 99} on this order</div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="footer1">
          {" "}
          <div className="content2">
            {" "}
            <div className="images3">
              {" "}
              <img
                className="footer-bank-ssl"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-ssl.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-visa"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-visa.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-mc"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-mc.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-nb"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-nb.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-cod"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-cod.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-rupay"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-rupay.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-paypal"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-paypal.png"
                alt=""
              />{" "}
              <img
                className="footer-bank-bhim"
                src="https://constant.myntassets.com/checkout/assets/img/footer-bank-bhim.png"
                alt=""
              />{" "}
            </div>{" "}
            <a href="/" className="contact-us">
              {" "}
              <span>Need Help ? Contact Us</span>{" "}
            </a>{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;
